import { produce } from 'immer'
import { mountStoreDevtool } from 'simple-zustand-devtools'
import { create } from 'zustand'

type ApprovalFormState = {
	isFormValid: boolean
	formValues: Record<string, any>
}

type ApprovalFormActions = {
	actions: {
		clearFormValues: () => void
		setFormValues: (fieldName: string, value: any) => void
		replaceFormValues: (values: Record<string, unknown>) => void
		setFormValidity: (isValid: boolean) => void
	}
}

/** Defaults when no network data was submitted (flags as strings; text fields blank). */
export const APPROVAL_ACCOUNT_NETWORK_FIELD_DEFAULTS = {
	vpcName: '',
	vpcCidrBlock: '',
	vpcAvailabilityZones: '',
	privateSubnetsCidr: '',
	tgwSubnetsCidr: '',
	requestTgwAttachment: 'true',
	isCoreVpc: 'false',
	createPrivateHostedZone: 'true',
	associateDnsResolverRules: 'true',
	useCentralizedVpcInterfaceEndpoints: 'true',
	privateHostedZoneName: '',
	secondaryCidrBlock: '',
	addSecondaryCidrBlock: false,
	addPublicCidrBlock: false,
	publicCidrBlock: ''
} as const

const initialFormValues = {
	...APPROVAL_ACCOUNT_NETWORK_FIELD_DEFAULTS,
	accountWorkloadType: 'Non-EKS' as 'EKS' | 'Non-EKS',
	ip_address_allocations: [] as Array<{
		id: string
		label: string
		cidrAzA: string
		cidrAzB: string
		cidrAzC?: string
	}>
}

const ApprovalFromStore = create<ApprovalFormState & ApprovalFormActions>(
	(set, _get) => ({
		isFormValid: false,
		formValues: initialFormValues,
		actions: {
			clearFormValues: () => set(() => ({ formValues: { ...initialFormValues } })),

			setFormValidity: (isValid) => set(() => ({ isFormValid: isValid })),

			replaceFormValues: (values) =>
				set(() => ({
					formValues: { ...initialFormValues, ...values } as Record<string, any>
				})),

			setFormValues: (fieldName, value) =>
				set((state) =>
					produce(state, (draft) => {
						draft.formValues[fieldName] = value
					})
				)
		}
	})
)

export const useApprovalFormStore = () => ApprovalFromStore((state) => state)

if (process.env.NODE_ENV !== 'production') {
	mountStoreDevtool('AccountsApprovalFormStore', ApprovalFromStore)
}
